<template>
  <div>
    <div class="personalCenter">
      <div class="count">
        <div class="title">
          <div><span></span>个人中心</div>
        </div>
        <div class="MyMessage" v-if="personal">
          <div class="user_box">
            <div>
              <img
                :src="sex"
                style="display: block; margin: 0 auto; width: 100px"
              />
            </div>
            <p class="user">{{ personal.name }}</p>
          </div>
          <div class="neirong">
            <p class="left">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名 :</p>
            <p class="right">{{ personal.name }}</p>
          </div>
          <div class="neirong">
            <p class="left">性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别 :</p>
            <p class="right">{{ personal.sex }}</p>
          </div>
          <div class="neirong">
            <p class="left">所&nbsp;&nbsp;在&nbsp;&nbsp;地 :</p>
            <p class="right">{{ personal.province }}</p>
          </div>
          <div class="neirong">
            <p class="left">所在城市 :</p>
            <p class="right">{{ personal.city }} {{ personal.area }}</p>
          </div>
          <div class="neirong">
            <p class="left">就读中学 :</p>
            <p class="right">{{ personal.school_name }}</p>
          </div>
          <div class="neirong">
            <p class="left">高考年份 :</p>
            <p class="right">{{personal.baccll_year}}</p>
        </div>
          <div class="neirong" v-if="personal.username">
            <p class="left">手&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;机 :</p>
            <p class="right">{{ personal.username }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      personal: [],
      sex: null,
      nianjis: ["高三", "高二", "高一", "初三", "初二", "初一"],
      nianji: "",
    };
  },
  mounted() {
    this.get_personalCenter();
    this.getYear()
  },
  created() {},
  methods: {
    //获取最低高考年份
    getYear(){
      var date=new Date();
      var year=date.getFullYear();
      var mounth=date.getMonth()+1;
      var day=date.getDate();
      if(mounth>=7){
          year+=1
      }
      if(mounth==6&&day>=7){
          year+=1
      }
      this.year=year;
    },
    get_personalCenter() {
      let _this = this;
      this.$ajax
        .post(
          this.G_uri + "/career/getUserInfo",
          {},
          {
            headers: {
              token: window.sessionStorage.getItem("ymtxToken"),
            },
          }
        )
        .then(function (res) {
          console.log(res);
          _this.personal = res.data.data;
          if (res.data.data.sex == "男") {
            _this.sex = "imgs/careerhome/icon_boy.png";
          } else {
            _this.sex = "imgs/careerhome/icon_girl.png";
          }
          if (_this.personal.baccll_year == "成年人") {
            _this.nianji = "成年人";
          } else {
            let number = Number(_this.personal.baccll_year);
            // 2023 
            _this.nianji = _this.nianjis[number - Number(_this.year)] || "成年人";
            console.log(Number(_this.year),number ,'_this.nianji ')
          }
        });
    },
  },
};
</script>
<style scoped lang="less">
.personalCenter {
  padding-left: 20px;
}
.title {
  background: #fff;
  color: #333;
  font-size: 15px;

  /* height: 45px; */
  /* line-height: 45px; */
  padding: 0px 10px;
  > div {
    padding: 16px 0;
    border-bottom: 1px solid #ccc;
    display: flex;
  }
  span {
    width: 3px;
    background: linear-gradient(90deg, #3c92f9 0%, #0c71eb 100%);
    margin-right: 10px;
  }
}
.head_Photo {
  width: 620px;
  // height: 100px;
  padding: 20px 0;
  margin: auto;

  text-align: center;
}
.MyMessage {
  padding: 0px 46px;
  box-sizing: border-box;
  min-height: 658px;
  background-color: #fff;
  .personal {
    line-height: 50px;
    color: #333;
    font-size: 16px;
    float: left;
  }
  .user_box {
    width: 171px;
    height: 151px;
    padding-top: 20px;
    margin: 0 auto;
    .user_img_boy {
      height: 100px;
      background: url(/imgs/gerenzhongxin/icon_boy.png) no-repeat center center;
    }
    .user_img_girl {
      height: 100px;
      background: url(/imgs/gerenzhongxin/icon_girl.png) no-repeat center center;
    }
    .user {
      line-height: 50px;
      text-align: center;
      font-size: 16px;
      color: #333;
    }
  }
  .neirong {
    font-size: 14px;
    line-height: 48px;
    height: 48px;
    border: 1px solid #f2f2f2;
    background-color: #fff;
    margin-bottom: 12px;
    color: #333;
    font-weight: 500;
    .left {
      padding-left: 12px;
      float: left;
      width: 85px;
      text-align: right;
    }
    .right {
      float: left;
      padding-left: 16px;
    }
  }
}
</style>


